import type { LeaderboardEntry, WorldCupGroupCompanyReward } from '../types/worldcup.types';

export interface SquadTvStadiumColumns {
  left: LeaderboardEntry[];
  right: LeaderboardEntry[];
}

/**
 * Splits the full ranked list into two scrolling columns for the Stadium board:
 * left = first half (top ranks), right = second half. Reading order flows
 * top-to-bottom down the left column, then continues down the right column.
 */
export function splitLeaderboardIntoColumns(entries: LeaderboardEntry[]): SquadTvStadiumColumns {
  const sorted = [...entries].sort((a, b) => a.rank - b.rank);
  const mid = Math.ceil(sorted.length / 2);
  return {
    left: sorted.slice(0, mid),
    right: sorted.slice(mid),
  };
}

/** Top-3 prize line for the top bar — null when the group has no configured rewards. */
export function getSquadTvPrizeLabel(
  rewards: WorldCupGroupCompanyReward[] | null | undefined,
): string | null {
  if (rewards == null || rewards.length === 0) return null;
  const first = rewards.find((reward) => reward.place === 1) ?? rewards[0];
  const label = first?.label?.trim();
  return label != null && label.length > 0 ? label : null;
}
